<template>
  <div id="perfumeGet" class="tc confirm">
    <div class="main_get centerX" @click.stop>
      <!--关闭按钮-->
      <div class="close-img absoluteItem" @click="close_self">
        <img src="../../assets/xiangshui/xiangshui(3).png" class="imgBlock" />
      </div>

      <!--盖子-->
      <img
        src="../../assets/xiangshui/xiangshui(2).png"
        class="top-img imgBlock"
      />

      <!--主体内容-->
      <div class="content">
        <!--有默认地址-->
        <div class="defult-address" v-show="show_address" v-cloak>
          <p class="p1" v-if="!item_info.award">
            {{ userinfo.current_energy }}
          </p>
          <p class="p2" v-if="!item_info.award">当前剩余精力值</p>
          <p class="p3" v-if="!item_info.award">
            选择兑换此香水将消耗{{ item_info.promotion_amount }}精力值
          </p>
          <p class="p4">
            {{ defult_address.province_name }}{{ defult_address.city_name
            }}{{ defult_address.district_name
            }}{{ defult_address.address }}&nbsp;&nbsp;{{
              defult_address.consignee
            }}&nbsp; <br />{{ defult_address.mobile }}
          </p>
          <p class="p5">
            <span class="s1" @click="show_address = !show_address"
              >添加地址</span
            >
            <span class="s2">默认地址</span>
          </p>
        </div>

        <!--无默认地址-->
        <div class="add-address" v-show="!show_address">
          <p class="p1" v-if="!item_info.award">
            {{ userinfo.current_energy }}
          </p>
          <p class="p2" v-if="!item_info.award">当前剩余精力值</p>
          <p class="p3" v-if="!item_info.award">
            选择兑换此香水将消耗{{ item_info.promotion_amount }}精力值
          </p>
          <div class="cheng_box" v-else></div>
          <form id="address" class="address-input">
            <div>
              <input
                type="tel"
                placeholder="输入手机号码"
                id="phone"
                v-model="sub_info.phone"
                maxlength="11"
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="输入收件人姓名"
                id="name"
                v-model="sub_info.name"
              />
            </div>
            <div class="city">
              <span
                @click="show_c = true"
                class="apostrophe"
                :class="{ darkspan: sub_info.province != '省' }"
                >{{ sub_info.province }}</span
              >
              <span
                @click="show_c = true"
                class="apostrophe"
                :class="{ darkspan: sub_info.city != '市' }"
                >{{ sub_info.city }}</span
              >
              <span
                @click="show_c = true"
                class="apostrophe"
                :class="{ darkspan: sub_info.district != '区' }"
                >{{ sub_info.district }}</span
              >
            </div>
            <div>
              <input
                type="text"
                placeholder="输入详细收货地址"
                id="address"
                v-model="sub_info.address"
              />
            </div>
          </form>
        </div>
      </div>

      <!--按钮-->
      <button @click="sub_mit" :class="{ click: !click_able }">
        {{ button_text }}
      </button>
    </div>

    <!--地址选择-->
    <div class="city-tc" v-show="show_c" @click="show_c = false">
      <div class="cymain" @click.stop>
        <h3>请选择所在地区</h3>
        <p class="ti">
          <span :class="{ here: c_now === 0 }" @click="choose_a(0)">{{
            p
          }}</span>
          <span :class="{ here: c_now === 1 }" @click="choose_a(1)">{{
            c
          }}</span>
          <span :class="{ here: c_now === 2 }" @click="choose_a(2)">{{
            d
          }}</span>
        </p>
        <ul class="items">
          <li
            v-for="(n, index) in cities[c_now]"
            :key="index"
            :data-id="n.id"
            @click="get_pro(index, $event)"
          >
            {{ n.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "perfumeGet",
  props: ["userinfo", "item_info"],
  data() {
    return {
      defult_address: {}, //用户的默认地址
      address_list: [], //用户的默认地址
      button_text: "确定",
      show_tc: true,
      show_address: false,
      click_able: true, //是否可与点击按钮的标识
      sub_info: {
        name: "", //用户姓名
        phone: "", //联系电话
        p_id: 0,
        c_id: 0,
        a_id: 0,
        province: "省",
        city: "市",
        district: "区",
        address: "",
      },
      cities: [[], [], []], //城市列表
      show_c: false, //是否显示城市地址选择
      c_now: 0, //选择地址时的指示标
      p: "省份",
      c: "市区",
      d: "街道",
    };
  },
  methods: {
    /**通知父组件关闭领取弹出 */
    close_self() {
      this.$emit("close_tc");
      this.get_address()
    },

    choose_a(index) {
      if (index !== 0) {
        if (this.cities[index].length > 0) {
          this.c_now = index;
        }
      } else {
        this.c_now = index;
      }
    },

    //请求城市数据列表
    get_pro(index, e) {
      let data = {};
      if (e != undefined) {
        data.id = e.target.dataset.id;
        if (this.c_now === 0) {
          this.sub_info.province = this.cities[0][index].name;
          this.sub_info.p_id = data.id;
          this.sub_info.c_id = 0;
          this.sub_info.a_id = 0;
          this.sub_info.city = "";
          this.sub_info.district = "";
        }
        if (this.c_now === 1) {
          this.sub_info.city = this.cities[1][index].name;
          this.sub_info.c_id = data.id;
        }
        if (this.c_now === 2) {
          this.sub_info.district = this.cities[2][index].name;
          this.sub_info.a_id = data.id;
          this.show_c = false;
          return;
        }
      }
      let _this = this;
      this.$jsonp(this.$apis("get_cities"), data, (res) => {
        if (e != undefined) {
          if (_this.c_now === 0) {
            _this.cities[1] = res.data.data.list;
            _this.c_now = 1;
          } else if (_this.c_now === 1) {
            if (res.data.data.list.length === 0) {
              this.show_c = false;
              _this.cities[2] = [];
              _this.sub_info.district = "";
              _this.sub_info.a_id = 0;
            } else {
              _this.cities[2] = res.data.data.list;
              _this.c_now = 2;
            }
          }
        } else {
          _this.cities[0] = res.data.data.list;
        }
      });
    },

    /**查看用户是否有默认地址 */
    get_address() {
      let _this = this;
      this.$jsonp(this.$apis("get_address"), {}, (res) => {
        let ls = res.data.data.list;
        if (ls.length != 0) {
          let get = false; //判断是否有默认地址
          //取默认地址
          for (const item of ls) {
            if (item.sign_building === "1") {
              _this.defult_address = item;
              _this.show_address = true;
              get = true;
            }
          }
          if (!get) {
            _this.defult_address = ls[0];
            _this.show_address = true;
          }
        }
      });
    },

    /**领取礼物 */
    get_gift_bag() {
      let _this = this;
      let data = {
        backpack_id: this.item_info.id,
        address_id: this.defult_address.address_id,
      };
      this.$jsonp(this.$apis("perfume_get_award"), data, (res) => {
        if (res.data.ret == 200) {
          _this.$tool.tipImg(res.data.data, "success");
          setTimeout(() => {
            _this.$emit("close_tc", "update");
          }, 1500);
        } else {
          _this.$tool.tipImg(res.data.data, "error");
        }
        _this.click_able = true;
      });
    },

    /**提交数据 */
    sub_mit() {
      // if (this.click_able) {
      //   console.log(9999999);
      //   this.click_able = false;
      // } else {
      //   console.log(888888);
      //   return false;
      // }
      //判断是添加地址还是领取物品
      if (this.show_address) {
        //领取礼物
        if (!this.item_info.award) {
          this.duiHuanFun();
        } else {
          this.get_gift_bag();
        }
        return;
      }

      //判断电话
      if (!this.$tool.checkPhone(this.sub_info.phone)) {
        this.$tool.tip("请填写正确的手机号码", "50%");
        return;
      }

      //判断名字
      if (this.sub_info.name == "") {
        this.$tool.tip("请填写收货人", "50%");
        return;
      }

      //判断详细地址
      if (this.sub_info.address == "") {
        this.$tool.tip("请填写详细地址", "50%");
        return;
      }

      if (this.sub_info.city == "") {
        this.$tool.tip("请选择城市地址", "50%");
        return;
      }
      let _this = this;
      let data = {
        consignee: this.sub_info.name,
        province_id: this.sub_info.p_id,
        city_id: this.sub_info.c_id,
        district_id: this.sub_info.a_id,
        address: this.sub_info.address,
        mobile: this.sub_info.phone,
        sign_building: "1",
      };
      this.$jsonp(this.$apis("add_address"), data, (res) => {
        if (res.data.data.status === 1) {
          _this.get_address();
        } else {
          _this.tipImg(res.data.data.msg, "error");
        }
        _this.click_able = true;
      });
    },

    // 兑换香水的操作
    duiHuanFun() {
      let _this = this;
      let data = {
        goods_id: _this.item_info.id,
        address_id: _this.defult_address.address_id,
      };
      this.$jsonp(this.$apis("perfume_SetRedeemPerfume"), data, (res) => {
        if (res.data.ret == 200) {
          _this.close_self();
          _this.$emit("close_tc", "update");
          _this.$tool.tipImg("兑换香水成功！", "success");
        } else {
          _this.$tool.tipImg(res.data.msg, "error");
        }
      });
    },
  },
  mounted: function () {
    this.get_address();
    this.get_pro();

    if (this.$tool.isAorI() == "Android") {
      var originalHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      window.onresize = function () {
        //键盘弹起与隐藏都会引起窗口的高度发生变化
        var resizeHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        if (resizeHeight - 0 < originalHeight - 0) {
          //当软键盘弹起，在此处操作
          document.querySelector(".main_get").style.top = "-70px";
        } else {
          //当软键盘收起，在此处操作
          document.querySelector(".main_get").style.top = "0";
        }
      };
    }
  },
  watch: {
    show_address(val) {
      if (val == 1) {
        this.button_text = "确定";
      } else {
        this.button_text = "添加新地址";
      }
    },
  },
};
</script>










<style scoped>
/**确认地址 */
.confirm .main_get {
  position: absolute;
  top: 0;
  width: 80%;
  transform-origin: left top;
  animation: showDownload_notop 0.2s;
  -webkit-animation: showDownload_notop 0.2s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.confirm button {
  display: block;
  width: 100%;
  border-radius: 3rem;
  background: #e74e61;
  font-size: 1.5rem;
  text-align: center;
  padding: 14px;
  box-shadow: 1px 1px 16px rgba(255, 255, 255, 0.27) inset,
    -1px -1px 16px rgba(255, 255, 255, 0.27) inset;
  color: #fff;
  font-weight: bold;
}
.confirm .click {
  transform: scale(0.9);
}
.confirm .content {
  overflow: hidden;
  width: 100%;
  min-height: 220px;
  margin-top: -16px;
  padding-bottom: 16px;
  background: linear-gradient(to bottom, #e74e60, #e2516e);
  background: -webkit-linear-gradient(top, #e74e60, #e2516e);
  margin-bottom: 2vh;
}
.confirm .top-img {
  width: 106%;
  z-index: 1;
}
.confirm .close-img {
  width: 50px;
  height: 50px;
  right: -7%;
  top: 18%;
  z-index: 2;
}
.confirm .close-img img {
  margin: 10px auto 0;
  width: 25px;
  height: 25px;
}
/**有默认地址 */
.defult-address .p1 {
  text-align: center;
  font-size: 1.875rem;
  color: #fff;
  font-weight: bold;
  margin-top: 10%;
}
.defult-address .p2 {
  text-align: center;
  font-size: 12px;
  color: #fff;
}
.defult-address .p4 {
  width: 80%;
  overflow: hidden;
  margin: 8% auto 11px auto;
  border-radius: 2rem;
  background: #fff;
  padding: 8px 15px;
  font-size: 12px;
  color: #999;
  text-align: justify;
  box-shadow: 0 0 15px rgba(255, 128, 155, 0.8) inset;
}
.defult-address .p3 {
  text-align: center;
  font-size: 11px;
  color: #231012;
  margin: 1vh 0 2vh 0;
}
.defult-address .p5 {
  text-align: right;
  font-size: 12px;
  color: #fff;
  padding-right: 11%;
}
.defult-address .p5 span {
  display: inline-block;
  padding-left: 20px;
}
.defult-address .s1 {
  background: url("../../assets/xiangshui/xiangshui(24).png") left center
    no-repeat;
  background-size: 12px;
  margin-right: 2.5rem;
}
.defult-address .s2 {
  background: url("../../assets/xiangshui/xiangshui(23).png") left center
    no-repeat;
  background-size: 12px;
}

/**没有默认地址 */
.add-address .p1 {
  text-align: center;
  font-size: 1.875rem;
  color: #fff;
  font-weight: bold;
  margin-top: 3vh;
}
.add-address .p2 {
  text-align: center;
  font-size: 12px;
  color: #fff;
}
.add-address .p3 {
  text-align: center;
  font-size: 11px;
  color: #231012;
  margin: 1vh 0 2vh 0;
}
.address-input {
  width: 80%;
  margin: 0 auto;
}
.address-input > div {
  border-radius: 3rem;
  background: #fff;
  box-shadow: 0 0 15px rgba(255, 128, 155, 0.8) inset;
  padding: 12px 0;
  margin-bottom: 2vh;
}
.address-input input::-webkit-input-placeholder {
  color: #c5c5c5;
}
.address-input input {
  width: 75%;
  border-radius: 3rem;
  background: none;
}
.address-input input,
.address-input span {
  position: relative;
  padding: 0 6%;
  background: none;
  font-size: 0.8125rem;
}
.address-input .city {
  padding: 0;
}
.address-input span {
  padding: 12px 6% 12px 6%;
  display: inline-block;
  width: 33.3333%;
  color: #c5c5c5;
}
.address-input .darkspan {
  color: #333;
}
.address-input span:nth-child(2) {
  border-left: 1px solid #fadce2;
  border-right: 1px solid #fadce2;
}
.address-input span::after {
  position: absolute;
  content: "";
  width: 7px;
  height: 5px;
  background: url("../../assets/xiangshui/xiangshui(1).png") center center
    no-repeat;
  background-size: 100%;
  top: 50%;
  right: 15%;
}

/**城市地址选择 */
.city-tc {
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 50;
}
.cymain {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 75%;
  padding: 16px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background: white;
  animation: show 0.4s;
  -webkit-animation: show 0.4s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.cymain h3 {
  font-size: 17px;
  margin-bottom: 33px;
}
.cymain .ti {
  font-size: 14px;
  margin-bottom: 30px;
}
.cymain .ti span {
  position: relative;
  margin-right: 20px;
}
.cymain .ti .here::after {
  position: absolute;
  content: "";
  width: 11px;
  height: 4px;
  border-radius: 4px;
  background: black;
  left: 50%;
  bottom: -5px;
  transform: translateX(-50%);
}
.cymain .items {
  height: 78%;
  overflow-y: scroll;
}
.cymain li {
  font-size: 13px;
  padding: 14px 0;
}
.cheng_box {
  height: 30px;
}
</style>
